const neutral = {
  canvas: '#0A0A0B',
  'surface-1': '#111113',
  'surface-2': '#17171A',
  'surface-3': '#1F1F23',
  line: '#26262B',
  'line-strong': '#34343A',
  fg: '#F3EFE6',
  'fg-body': '#D6D0C4',
  'fg-muted': '#A39D92',
  'fg-subtle': '#8E887C',
  'fg-faint': '#5C574F',
  'on-gold': '#17130B',
};

const scales = {
  gold: { 50: '#FAF5E8', 100: '#F3E8CC', 200: '#EBD9AE', 300: '#E2C994', 400: '#D6BA82', 500: '#CDAE74', 600: '#B08F55', 700: '#8C6F3E', 800: '#5E4A2A', 900: '#2B2316', 950: '#1A150D' },
  gain: { 50: '#EEF8F3', 100: '#D3EEE1', 200: '#B4E2CC', 300: '#9AD6B8', 400: '#6BBF97', 500: '#4FA47E', 600: '#3C8063', 700: '#2E634D', 800: '#1F4434', 900: '#12241C', 950: '#0C1813' },
  loss: { 50: '#FDF0EE', 100: '#FADBD7', 200: '#F5BFB8', 300: '#F0A399', 400: '#E3796D', 500: '#C9584D', 600: '#A3443B', 700: '#7D342D', 800: '#55241F', 900: '#2A1513', 950: '#1C0E0C' },
  warn: { 50: '#FCF4EA', 100: '#F8E5CC', 200: '#F2D2A8', 300: '#EDC08D', 400: '#E2A35C', 500: '#C9853D', 600: '#A1692F', 700: '#7A5024', 800: '#523618', 900: '#2A1D10', 950: '#1C130A' },
  info: { 50: '#F0F4FA', 100: '#DCE6F4', 200: '#C6D6EE', 300: '#B0C6E6', 400: '#86A8D8', 500: '#5F86BD', 600: '#4A6A97', 700: '#395172', 800: '#27374D', 900: '#141C29', 950: '#0D131C' },
  // Electric blue of the Trading section (its accent, and its mark in the
  // rest of the app).
  trade: { 50: '#EAF4FF', 100: '#CCE5FF', 200: '#9FCDFF', 300: '#6DB2FF', 400: '#3D95FF', 500: '#1F7CFF', 600: '#1663D6', 700: '#134EA8', 800: '#113A78', 900: '#0B2347', 950: '#07172F' },
};

// The Trading universe ([data-universe="trading"] on <html>): colder blue
// graphite surfaces, and the accent (gold-*) remapped to the electric blue,
// so every component switches without a second set of classes. Gold stays
// reserved to the wealth side of the app.
const trading = {
  neutral: {
    canvas: '#070A0F',
    'surface-1': '#0C1119',
    'surface-2': '#111823',
    'surface-3': '#18212E',
    line: '#202A39',
    'line-strong': '#2D394B',
    fg: '#EAF1FA',
    'fg-body': '#C8D3E2',
    'fg-muted': '#93A1B5',
    'fg-subtle': '#7E8CA1',
    'fg-faint': '#4C596B',
    'on-gold': '#03101F',
  },
  accent: 'trade',
  info: { 50: '#F3F0FD', 100: '#E2DBFA', 200: '#CDC0F5', 300: '#B7A5F0', 400: '#9C85E8', 500: '#7F66D6', 600: '#6650B0', 700: '#4E3D87', 800: '#362A5E', 900: '#1C1631', 950: '#130F21' },
};

const chart = {
  series: ['#CDAE74', '#E8E1D3', '#6BBF97', '#86A8D8', '#B79CC7', '#C9B79C', '#C98A5E', '#8E9AA6'],
  cash: '#6F6A61',
  grid: '#26262B',
  axis: '#8E887C',
  cursor: '#CDAE74',
  surface: '#1F1F23',
  border: '#34343A',
  gold: '#CDAE74',
  goldSoft: '#E2C994',
  gain: '#4FA47E',
  gainText: '#6BBF97',
  loss: '#C9584D',
  lossText: '#E3796D',
  fg: '#F3EFE6',
  body: '#D6D0C4',
  canvas: '#0A0A0B',
};

// Chart colours in the Trading universe. No object spread in this
// CommonJS file: Babel would inject an ES module helper and break the
// default import used by the app.
const tradingChart = Object.assign({}, chart, {
  series: ['#3D95FF', '#E8EEF7', '#6BBF97', '#9C85E8', '#E2A35C', '#6DB2FF', '#C9584D', '#8E9AA6'],
  grid: '#202A39',
  axis: '#7E8CA1',
  cursor: '#3D95FF',
  surface: '#18212E',
  border: '#2D394B',
  gold: '#3D95FF',
  goldSoft: '#6DB2FF',
  fg: '#EAF1FA',
  body: '#C8D3E2',
  canvas: '#070A0F',
});

module.exports = { neutral, scales, chart, trading, tradingChart };
